import { render, staticRenderFns } from "./downloadRow.vue?vue&type=template&id=21b2c94c&scoped=true&"
import script from "./downloadRow.vue?vue&type=script&lang=js&"
export * from "./downloadRow.vue?vue&type=script&lang=js&"
import style0 from "./downloadRow.vue?vue&type=style&index=0&id=21b2c94c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b2c94c",
  null
  
)

export default component.exports